<template>
    <div
        class="cvv_popup_overlay open"
        @click="cvc_popup = false"
    >
        <div class="cvv_popup_wrap">
                <RotateLoader
                  :loading="true"
                  :color="'#fff'" />
        </div>
    </div>
</template>

<script setup>
import { onMounted, onUnmounted } from "vue";
import { RotateLoader } from "vue3-spinner";

onMounted(() => {
    document.querySelector('body').classList.add('noscroll')
})

onUnmounted(() => {
    document.querySelector('body').classList.remove('noscroll')
})
</script>

<style >
.noscroll {margin: 0; height: 100%; overflow: hidden}
</style>